// Frontend copy of the name-normalization logic in
// api/routes/functions/sportsGameOdds.js (kept separate since that file
// imports node-fetch and isn't browser-safe). Converts MFL's "Last, First"
// format and SportsGameOdds' "First Last" format to a common lowercase key.
export const normalizePlayerName = (name) => {
  const str = String(name || '');
  const [last, first] = str.includes(',') ? str.split(',').map((s) => s.trim()) : [null, null];
  const normalized = first && last ? `${first} ${last}` : str;
  return normalized.toLowerCase().replace(/[^a-z\s]/g, '').replace(/\s+/g, ' ').trim();
};
